import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import ReactSelect from "react-select";
import infoimg from "./info.png";
import AnimatedText from "../components/Animation/AnimatedText";
import LoadingDots from "../components/Animation/LoadingDots";
import Icon from "../components/icon";
import AttachmentIcon from "@mui/icons-material/Attachment";
import localforage from "localforage";
import { Button, Grid, Switch, TextField, Tooltip } from "@mui/material";
import "./style.css";
import MyDropzone from "../../../../components/uploadFiles/MyDropzone";
import { useAppServices } from "../../../../hook/services";
import { useUserInfo } from "../../../../context/user";
import Icons from "../../../../components/icons";
import CommonModal from "../../../Settings/components/ResetContext/components/DumpModal";
import { useUsersContext } from "../../../../context/usersContext";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { Sparkles } from "lucide-react";
import ContactToSupportModal from "../../../../components/ContactToSupportModal";
import { useQueryClient } from "@tanstack/react-query";
import { useCreateAgent, agentsKeys, useGenerateAgentPrompt } from "../../../../queries/agents";
function ModalComponent({
  open,
  onClose,
  handleRefresh,
  pluginsdata,
  numberOfAgents,
}) {
  const AppService = useAppServices();
  const queryClient = useQueryClient();
  const createAgent = useCreateAgent();
  const generateAgentPrompt = useGenerateAgentPrompt();
  const [agency] = [];
  const [contentCreativity, setContentCreativity] = useState(1);
  const userInfo = useUserInfo()[0];
  const userActiveLocation = useUserInfo()[4];
  const [btgen, setBtgen] = useState(1);
  const [waiting, setWaiting] = useState(false);
  const [promptQuery, setPromptQuery] = useState("");
  const [promptstep, setpromptstep] = useState(0);
  const [promptQueryError, setPromptQueryError] = useState("");
  const [FormData1, setFormData1] = useState([]);
  const [showStep, setshowStep] = useState(false);
  const [apiType, setapiType] = useState("");
  const [isForSupport, setIsForSupport] = useState(false);
  const [uploadedFileData, setUploadedFileData] = useState([]);
  const [alertModel, setAlertModel] = useState(false);
  const [limitFull, setLimitFull] = useState(false);
  const { products, isHighestPlan } = useUsersContext();
  const activePlan = products?.filter((item) => item.activePlan)?.[0];
  const navigate = useNavigate();
  const [openLimitModal, setOpenLimitModal] = useState(false);

  const handleIsSupportCheck = (e) => {
    setIsForSupport(e.target.checked);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setWaiting(true);
    const payload = {
      name: FormData1.promptName,
      instructions: FormData1.description,
      model: "openai/gpt-4o",
      temperature: contentCreativity,
      top_p: btgen,
      account_id: userActiveLocation.id,
      profile_id: userActiveLocation.id,
      readonly: true,
      type: "account",
      status: false,
      assist_type: "account-only",
      for_support: true,
      advanceConversationMode: advanceConversationMode,
      numberOfMessages: numberOfMessages,
      messageDelayTime: messageDelayTime,
      function_names: activePlugins,
      agency_id: userActiveLocation.agency_id,
    };

    try {
      await createAgent.mutateAsync(payload);
      setShowAdvancedSettings(false);
      setAdvanceConversationMode(false);
      setNumberOfMessages(0);
      setMessageDelayTime(0);
      setActivePlugins("");

      queryClient.invalidateQueries({
        queryKey: agentsKeys.list(userInfo?._id, userActiveLocation?.id),
      });
      handleRefresh();
      onClose();

      setContentCreativity(1);
      setBtgen(1);
      setpromptstep(0);
      setFormData1([]);
      setPromptQuery("");
    } catch (error) {
      console.error("Error creating assistant:", error);
    } finally {
      setWaiting(false);
    }
  };

  const handleCCInputChange = (event) => {
    const tempSliderValue = parseFloat(event.target.value);
    const maxSliderValue = parseFloat(event.target.max);
    const progress = (tempSliderValue / maxSliderValue) * 100;

    const rangeInput = document.querySelector(".range-input");
    if (rangeInput) {
      rangeInput.style.background = `linear-gradient(to right, hsl(var(--muted-foreground)) ${progress}%, hsl(var(--border)) ${progress}%)`;
    }

    setContentCreativity(tempSliderValue);
  };

  const formatString = (str) => {
    // Replace underscores with spaces
    str = str.replace(/_/g, " ");

    // Add space before each capital letter, ensuring no double spaces
    str = str.replace(/([a-z])([A-Z])/g, "$1 $2");

    // Trim and return the final result
    return str.trim();
  };

  const handleBtInputChange = (event) => {
    const tempSliderValue = parseFloat(event.target.value);
    const maxSliderValue = parseFloat(event.target.max);
    const progress = (tempSliderValue / maxSliderValue) * 100;

    const rangeInput = document.querySelector(".range-input1");
    if (rangeInput) {
      rangeInput.style.background = `linear-gradient(to right, hsl(var(--muted-foreground)) ${progress}%, hsl(var(--border)) ${progress}%)`;
    }
    setBtgen(tempSliderValue);
  };

  const GeneratePrompt = async () => {
    setpromptstep(1);
    try {
      const payload = {
        account_id: userActiveLocation.id,
        username: "Account Prompt Generator",
        promptQuery: promptQuery,
        type: "assistant",
        file_ids: uploadedFileData,
      };

      const response = await generateAgentPrompt.mutateAsync(payload);

      if (response) {
        setpromptstep(2);
        setFormData1((prevData) => ({
          ...prevData,
          promptName: response?.data?.title || "",
          description: response?.data?.content || "",
        }));
        var temperature = Number(response?.data?.tempratore);
        var top_p = Number(response?.data?.top_p);
        setContentCreativity(temperature);
        setBtgen(top_p);
      }
    } catch (error) {
      return error;
    }
  };
  const handlestep1 = () => {
    if (promptQuery === "") {
      setPromptQueryError(true);
      return false;
    }
    setPromptQueryError(false);
    GeneratePrompt();
  };
  const detectEnterPress = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      if (numberOfAgents >= parseInt(activePlan?.agenct_config?.agent_limit)) {
        setLimitFull(true);
        return;
      }
      handlestep1();
    }
  };
  const selectassistanttype = (e) => {
    if (e.target.value === "agency" || e.target.value === "automation") {
      setshowStep(false);
      return true;
    }
    if (e.target.value === "account-specific") {
      setapiType("team");
      setshowStep(true);
      return true;
    }
    if (e.target.value === "user-specific") {
      setapiType("user");
      setshowStep(true);
      return true;
    }
  };

  useEffect(() => {
    if (limitFull) {
      if (
        userActiveLocation?.type !== "free" ||
        (activePlan?.isenable_account && activePlan?.developer_plan) ||
        isHighestPlan()
      )
        setOpenLimitModal(true);
      else
        setTimeout(() => {
          navigate("/app/settings", { state: { tab: "Pricing", text: "" } });
        }, 500);
    }
  }, [limitFull]);

  const [showAdvancedSettings, setShowAdvancedSettings] = useState(false);
  const [advanceConversationMode, setAdvanceConversationMode] = useState(false); // State for the toggle button
  const [numberOfMessages, setNumberOfMessages] = useState(0); // State for the first number input field
  const [messageDelayTime, setMessageDelayTime] = useState(0);
  // console.log("toggle Value", messageDelayTime)
  // Toggle Advanced Settings
  const handleAdvancedSettingsClick = () => {
    setShowAdvancedSettings(!showAdvancedSettings);
  };

  // Handle Toggle Button Change
  const handleToggleChange = (event) => {
    setAdvanceConversationMode(event.target.checked);
  };

  // Handle Number Input Change
  const handleNumberInputChange = (event, setter) => {
    setter(event.target.value);
  };

  // Array to store active plugin names
  const [activePlugins, setActivePlugins] = useState([]);
  // console.log("plugins", activePlugins)
  // Handle toggle change for both plugins
  const handlePluginsChange = (event) => {
    const pluginName = pluginsdata.find(
      (plugin) => plugin.name === event.target.name,
    ).name;

    // Toggle the ID in the active plugins array
    setActivePlugins((prevState) => {
      if (prevState.includes(pluginName)) {
        // If the ID is already in the active array, remove it
        return prevState.filter((name) => name !== pluginName);
      } else {
        // Otherwise, add it to the active array
        return [...prevState, pluginName];
      }
    });
  };

  useEffect(() => {
    setpromptstep(0);
    setPromptQuery("");
    setFormData1([]);
    if (promptstep > 0) {
      setUploadedFileData([]);
    }
  }, [open]);
  const [crackFile, setcrackFile] = useState("");
  const UploadFile = async (files) => {
    setcrackFile("");
    try {
      const user = await localforage.getItem("user").then((userObject) => {
        if (userObject) {
          return userObject;
        } else {
          console.log("No user found in localForage");
        }
      });
      console.log(user);
      const formData = new FormData();
      for (let file of files) {
        formData.append("file", file.file);
      }

      const assistantIds = [agency?.assistant_id];
      formData.append(
        "profile_id",
        agency?.ghl ? agency.ghl.location_id : agency.location_id,
      );
      formData.append("username", "AgencyUser");
      formData.append("model_name", "openai/gpt-4o");
      // formData.append("assistant_ids", JSON.stringify(assistantIds));

      const { response } = await AppService.chat.saveMultimedia({
        payload: formData,
        toaster: false,
      });

      setUploadedFileData((prevData) => [
        ...(prevData || []),
        ...(response.data || []),
      ]);
      if (response.crashfiles.length > 0) {
        setcrackFile(
          `Some Files are Currupted due to token exceed ${response.crashfiles.join(
            ",",
          )}`,
        );
        setTimeout(() => {
          setAlertModel(false);
        }, 3000);
      } else {
        setAlertModel(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const removeFile = (indexToRemove) => {
    const updatedData = uploadedFileData.filter(
      (_, index) => index !== indexToRemove,
    );
    setUploadedFileData(updatedData);
  };

  return (
    <CommonModal
      isOpen={open}
      onClose={onClose}
      title="Create Agent"
      showAlert={false}
    >
      <div className="max-h-[calc(100vh-300px)] overflow-y-auto w-full">
        <div className="text-left">
          {promptstep == 0 && (
            <>
              <p
                className="roundofaddprompt z-w-60"
                style={{ display: "flex", alignItems: "center" }}
              >
                <Icon id={"magicstar"} />
                <AnimatedText
                  text="What do you want your agent to do?"
                  style={{ marginLeft: "20px" }}
                  speed={50}
                />
              </p>

              <div className="input-container" style={{ position: "relative" }}>
                <textarea
                  value={promptQuery}
                  required
                  placeholder={"Start typing..."}
                  name="promptQuery"
                  onChange={(e) => setPromptQuery(e.target.value)}
                  onKeyDown={(e) => detectEnterPress(e)}
                  className="input_od_addPrompt"
                  style={{
                    width: "100%",
                    padding: "20px", // Add padding as needed
                    borderRadius: "8px", // Adjust border radius as needed
                    maxHeight: "200px",
                    resize: "none", // Prevent manual resizing
                    border: "1px solid black",
                  }}
                  rows={1} // Start with a single row
                  onInput={(e) => {
                    e.target.style.height = "auto"; // Reset height
                    e.target.style.height = `${e.target.scrollHeight}px`; // Set height to scrollHeight
                  }}
                />

                <button
                  onClick={handlestep1}
                  style={{ position: "absolute", right: "10px", top: "10px" }}
                >
                  <Icon id="sendChat" className="chat__input-icon" />
                </button>
              </div>
              {promptQueryError && (
                <small style={{ color: "red" }}>Should not be empty</small>
              )}

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-start",
                  marginRight: "10px",
                }}
              ></div>
            </>
          )}
          {promptstep == 1 && (
            <>
              <p
                className="roundofaddprompt z-w-100 text-center"
                style={{
                  marginBottom: 0,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Icon id={"magicstar"} />
                <span style={{ display: "inline-block", marginLeft: "10px" }}>
                  Creating Agent
                </span>
                <LoadingDots speed={100} />
              </p>
            </>
          )}
          <form onSubmit={handleSubmit}>
            {promptstep == 2 && (
              <Grid container spacing={0}>
                <Grid item xs={12}>
                  <div className="mt-2">
                    <label className="text-foreground">Agent Name</label>
                    <input
                      className="form-control-agust"
                      placeholder="Agent Name"
                      name="assistant_name"
                      onChange={(e) =>
                        setFormData1({
                          ...FormData1,
                          promptName: e.target.value,
                        })
                      }
                      defaultValue={FormData1.promptName}
                      required
                    />
                  </div>
                </Grid>

                <Grid item xs={12} style={{ marginTop: "14px" }}>
                  <div className="mt-2">
                    <label
                      className="text-foreground"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        position: "relative",
                        width: "fit-content",
                      }}
                    >
                      <span>Purpose</span>

                      <Tooltip
                        PopperProps={{
                          sx: {
                            "& .MuiTooltip-tooltip": {
                              maxWidth: "none",
                              width: "400px", // Set your desired width here
                            },
                          },
                        }}
                        placement="top"
                        title={"supperAdminData.assistant_purpose"}
                      >
                        <img
                          style={{ width: "30px", cursor: "pointer" }}
                          src={infoimg}
                        />
                      </Tooltip>
                    </label>

                    <textarea
                      className="form-control-agust"
                      name="purpose"
                      rows={20}
                      style={{
                        width: "100%",
                        padding: "14px",
                        resize: "vertical",
                      }}
                      value={FormData1.description}
                      onChange={(e) =>
                        setFormData1({
                          ...FormData1,
                          description: e.target.value,
                        })
                      }
                      required
                    />
                  </div>
                </Grid>

                <Grid item xs={6} style={{ marginTop: "10px" }}>
                  <div className="mt-2">
                    <label
                      className="text-foreground"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <span>Content Creativity</span>
                      <Tooltip
                        PopperProps={{
                          sx: {
                            "& .MuiTooltip-tooltip": {
                              maxWidth: "none",
                              width: "400px", // Set your desired width here
                            },
                          },
                        }}
                        placement="top"
                        title={"supperAdminData.content_creativity"}
                      >
                        <img
                          style={{ width: "30px", cursor: "pointer" }}
                          src={infoimg}
                        />
                      </Tooltip>
                    </label>

                    <div style={{ display: "flex", alignItems: "center" }}>
                      <input
                        type="range"
                        value={contentCreativity}
                        min="0"
                        max="2"
                        step={"0.01"}
                        onChange={handleCCInputChange}
                        className="range-input"
                      />
                      <input
                        type="number"
                        value={contentCreativity}
                        min="0"
                        max="2"
                        step="0.01"
                        onChange={(event) => handleCCInputChange(event)}
                        style={{
                          maxWidth: "50px",
                          fontSize: "14px",
                          margin: "2px",
                          padding: "0px 2px",
                          borderRadius: "5px",
                          border: "1px solid Black",
                        }}
                        className="height_25 bg_transparent removeControl"
                      />
                    </div>
                  </div>
                </Grid>

                <Grid item xs={6} style={{ marginTop: "10px" }}>
                  <div className="mt-2">
                    <label
                      className="text-foreground"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <span>Balance Text Generation</span>
                      <Tooltip
                        PopperProps={{
                          sx: {
                            "& .MuiTooltip-tooltip": {
                              maxWidth: "none",
                              width: "400px", // Set your desired width here
                            },
                          },
                        }}
                        placement="top"
                        title={"supperAdminData.balance_text_generation"}
                      >
                        <img
                          style={{ width: "30px", cursor: "pointer" }}
                          src={infoimg}
                        />
                      </Tooltip>
                    </label>

                    <div style={{ display: "flex", alignItems: "center" }}>
                      <input
                        type="range"
                        value={btgen}
                        min="0"
                        max="1"
                        step={"0.01"}
                        onChange={handleBtInputChange}
                        className="range-input1"
                      />

                      <input
                        type="number"
                        value={btgen}
                        min="0"
                        max="1"
                        step="0.01"
                        onChange={(event) => handleBtInputChange(event)}
                        style={{
                          maxWidth: "50px",
                          fontSize: "14px",
                          margin: "2px",
                          padding: "0px 2px",
                          borderRadius: "5px",
                          border: "1px solid Black",
                        }}
                        className="height_25 bg_transparent"
                      />
                    </div>
                  </div>
                </Grid>
                {/* Advanced Settings Button */}
                <div style={{ width: "100%", textAlign: "right" }} mt={2}>
                  <Button
                    onClick={handleAdvancedSettingsClick}
                    style={{ color: "hsl(var(--foreground))" }}
                  >
                    Advanced Settings
                  </Button>
                </div>

                {showAdvancedSettings && (
                  <div style={{ marginTop: "0px", padding: "10px" }}>
                    <h2
                      className="text-foreground text-left"
                      style={{
                        fontWeight: "700",
                        marginBottom: "20px",
                      }}
                    >
                      {" "}
                      Advance Setting{" "}
                    </h2>
                    <Grid container spacing={2}>
                      {/*    <Grid item xs={12} style={{ marginBottom: '20px' }}>
                          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>

                              <label className="text-foreground" style={{ marginRight: '0px' }}>Switch on advanced conversation mode</label>
                              <Tooltip PopperProps={{
                                sx: {
                                  "& .MuiTooltip-tooltip": {
                                    maxWidth: "none",
                                    width: "400px",
                                    marginTop: "30px"
                                  },
                                },
                              }} placement="top" title={"supperAdminData.pluginInfo"}>
                                <img style={{ width: "30px", cursor: "pointer" }} src={infoimg} />
                              </Tooltip>

                            </div>
                            <div>
                              <Switch
                                checked={advanceConversationMode}
                                onChange={handleToggleChange}
                                name="enableFeature"
                                inputProps={{ 'aria-label': 'Enable Feature' }}
                              />
                            </div>

                          </div>
                        </Grid>

                        <Grid item xs={12} style={{ marginBottom: '15px' }}>
                          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <label className="text-foreground">Number of messages</label>
                            <TextField
                              className="numberMessages"
                              type="number"
                              value={numberOfMessages}
                              onChange={(e) => handleNumberInputChange(e, setNumberOfMessages)}
                              fullWidth
                              inputProps={{
                                min: 2,
                                max: 10, // Set max to 10
                                step: 1 // Optional: Only allow whole numbers
                              }}
                              style={{
                                width: '30%',
                                padding: '0 8px',
                                height: '16px !important',
                                fontSize: '14px',
                                lineHeight: '16px',
                              }}
                            />
                          </div>
                        </Grid>

                        <Grid item xs={12} style={{ marginBottom: '20px' }}>
                          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <label className="text-foreground">Delay between messages Seconds:</label>
                            <TextField
                              type="number"
                              value={messageDelayTime}
                              onChange={(e) => handleNumberInputChange(e, setMessageDelayTime)}
                              fullWidth
                              inputProps={{ min: 0 }}
                              style={{
                                width: '30%',
                                padding: '0 8px', // Adjust the padding to match the reduced height
                              }}
                            />
                          </div>
                        </Grid> */}

                      {pluginsdata && (
                        <>
                          <h2
                            className="text-foreground text-left ms-4"
                            style={{ fontWeight: "700" }}
                          >
                            {" "}
                            Plugins{" "}
                          </h2>
                          {pluginsdata?.map((plugin) => (
                            <Grid item xs={12} key={plugin.id}>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                }}
                              >
                                <label
                                  className="text-foreground"
                                  style={{ marginRight: "10px" }}
                                >
                                  {formatString(plugin.name).toUpperCase()}
                                </label>
                                <Switch
                                  checked={activePlugins.includes(plugin.name)}
                                  onChange={handlePluginsChange}
                                  name={plugin.name}
                                  inputProps={{
                                    "aria-label": `Enable ${formatString(
                                      plugin.name,
                                    )}`,
                                  }}
                                />
                              </div>
                            </Grid>
                          ))}
                        </>
                      )}
                    </Grid>
                  </div>
                )}
                <div
                  style={{
                    width: "100%",
                    marginTop: "10px",
                    textAlign: "right",
                  }}
                  mt={2}
                >
                  <button
                    className="savebtn-setting w-100 position-relative"
                    type="submit"
                    disabled={waiting}
                  >
                    {waiting && (
                      <div
                        className="spinner"
                        style={{
                          width: "16px",
                          height: "16px",
                          display: "inline-block",
                          marginRight: "8px",
                        }}
                      ></div>
                    )}
                    Create Agent
                  </button>
                </div>
              </Grid>
            )}
          </form>
        </div>

        {alertModel && (
          <div className="modal-zz" onClick={() => setAlertModel(false)}>
            <div
              className="modal-content-zz"
              onClick={(e) => e.stopPropagation()}
            >
              <p
                style={{
                  position: "absolute",
                  right: 5,
                  width: "12px",
                  top: "10px",
                  height: "12px",
                  cursor: "pointer",
                }}
                onClick={() => setAlertModel(false)}
              ></p>

              <MyDropzone UploadFile={UploadFile} />
              <p
                style={{
                  textAlign: "center",
                  color: "red",
                }}
              >
                {crackFile}
              </p>
            </div>
          </div>
        )}
      </div>
      <ContactToSupportModal
        isOpen={openLimitModal}
        onClose={() => setOpenLimitModal(false)}
      />
    </CommonModal>
  );
}

ModalComponent.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  handleRefresh: PropTypes.func,
};

function Modal({
  products,
  apps,
  handleRefresh,
  pluginsdata,
  numberOfAgents,
  activeProduct,
}) {
  const [openAddMember, setOpenAddMember] = useState(false);
  const userInfo = useUserInfo()[0];
  const userActiveLocation = useUserInfo()[4];
  const activePlan = products?.filter((item) => item.activePlan)?.[0];
  const [openLimitModal, setOpenLimitModal] = useState(false);
  const { agentBuilder, isHighestPlan, setSelectedAssistant } =
    useUsersContext();
  const navigate = useNavigate();


  const hasAgentQuota =
    userActiveLocation?.unlimited_ai_agents === true ||
    Number(userActiveLocation?.number_of_ai_agents || 0) >
    Number(userActiveLocation?.number_of_created_agents || 0);

  const handlePostMessageToChat = () => {
    setSelectedAssistant({
      assistant_id: agentBuilder,
      assistant_name: "Agent Builder",
      message: "force restart",
    });
    setTimeout(() => {
      navigate("/app/chat");
    }, 100);
  };

  return (
    <div>
      {userInfo?.role?.toLowerCase() === "admin" && hasAgentQuota && (
        <button
          className="inline-flex items-center gap-2 h-9 px-3 rounded-md bg-foreground text-background hover:bg-foreground/90 text-sm font-medium"
          onClick={(e) => {
            if (
              userActiveLocation.type === "free" ||
              activeProduct?.create_agents
            )
              handlePostMessageToChat();
            else if (
              userActiveLocation?.type === "free" ||
              (!activePlan?.isenable_account && !activePlan?.developer_plan) ||
              isHighestPlan()
            )
              setOpenLimitModal(true);
            else
              navigate("/app/settings", {
                state: {
                  tab: "Pricing",
                  text: "Upgrade to build a custom AI Agent",
                },
              });
          }}
        >
          <Sparkles className="w-4 h-4" />
          <span>Build a Custom Agent</span>
        </button>
      )}

      <ModalComponent
        open={openAddMember}
        onClose={() => setOpenAddMember(false)}
        products={products}
        apps={apps}
        handleRefresh={handleRefresh}
        pluginsdata={pluginsdata}
        numberOfAgents={numberOfAgents}
      />
      <ContactToSupportModal
        isOpen={openLimitModal}
        onClose={() => setOpenLimitModal(false)}
      />
    </div>
  );
}

Modal.propTypes = {
  products: PropTypes.array,
  handleRefresh: PropTypes.func,
  apps: PropTypes.array,
};

export default Modal;
